export default __webpack_public_path__ + "static/media/08.679d75ab.jpg";